
import React, { ReactNode, useState } from 'react';
import axios from 'axios';
// import '../Pincodefinder/Style.css';
import '../Pincodefinder/Track.css';

import '../Pincodefinder/ascargo.css';

// import '../Steelcity/css/style.css';
// import '../Steelcity/css/bootstrap.min.css';
// import '../Steelcity/css/responsive.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Row, Col, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';
import personPhoto from "../Logo/personPhoto.png";
import jdcargo from "../Logo/jdcargologo.png";
import Aslogistics from "../Logo/Aslogisticslogo.png";
import as from "../Logo/Aslogisticslogofuture.png";
import serviceIcon from "../Logo/service247.png";
import asbaner from "../Logo/asbanner.jpg";



interface TempodEntry {
  DocketNo: string;
  DelvDt: string;
  DelvTime: string;
  Destination_Name: string;
  Remark?: string | null;   // ✅ FIX
  Status: string;
}


interface TrackingRecord {
  StatusEntry: TempodEntry[]; 
  DocketNo: string;
  InvoiceNo: string;
  ExptDateDelivery: string;
  VendorAwbNo: string;
  bookdate: string;
  ConsigneeName: string;
  Status: string;
  Qty: string;
  Destination_Name: string;
  Origin_Name: string;
  Consignee_Mob: string;
  Mode: string;
  EWaybill: string,
  recvName: string;
  statusDt: string;
  delvTime: string;
  remark: ReactNode;
  tempodData: TempodEntry[];
  ImageLink: string;
}

const AsTracking: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const [trackingData, setTrackingData] = useState<TrackingRecord[]>([]);
  const [showImage, setShowImage] = useState(false);
  const [error, setError] = useState('');
  const [currentStep, setCurrentStep] = useState(1);
  const [menuOpen, setMenuOpen] = useState(false);


  // const news = [
  //   {
  //     date: '10/09/2025',
  //     title: 'As Logistics Successfully Delivers International Shipments Across Europe and the Middle East',
  //     link: '#',
  //     isNew: true,
  //   },
  //   {
  //     date: '01/04/2025',
  //     title: 'As Logistics Achieves Record On-Time International Delivery Performance',
  //     link: '#',
  //     isNew: true,
  //   },
  //   {
  //     date: '15/08/2025',
  //     title: 'As Logistics Expands International Courier Services to 50+ Countries',
  //     link: '#',
  //     isNew: true,
  //   },
  //   {
  //     date: '11/09/2025',
  //     title: 'As Logistics Completes High-Value International Shipments for Global E-commerce Clients',
  //     link: '#',
  //   },
  //   {
  //     date: '06/02/2025',
  //     title: 'As Logistics Introduces Real-Time Tracking for International Shipments',
  //     link: '#',
  //   },
  //   {
  //     date: '08/05/2023',
  //     title: 'As Logistics Delivers Time-Critical International Cargo with Customs Clearance Support',
  //     link: '#',
  //   },
  //   {
  //     date: '02/03/2022',
  //     title: 'As Logistics Marks Successful Launch of International Express Delivery Services',
  //     link: '#',
  //   },
  // ];



  const statusToStep: { [key: string]: number } = {
    Shipped: 1,
    'In Transit': 2,
    Delivered: 3,
  };

  const handleButtonClick = () => setShowImage(!showImage);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.slice(0, 200);
    setSearchValue(inputValue);
    setError('');
    setTrackingData([]);
  };



  const fetchData = async () => {
    try {
      setError(""); // clear previous error

      if (searchValue.trim() === "") {
        setError("Please enter one or more tracking numbers separated by commas.");
        alert("Please enter one or more tracking numbers separated by commas.");
        return;
      }

      const searchInputs = searchValue
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);

      if (searchInputs.length === 0) {
        setError("Please enter valid tracking numbers or reference numbers.");
        alert("Please enter valid tracking numbers or reference numbers.");
        return;
      }

      const res = await axios.get(
        "https://jaimarutilogistics.com/ShipwayApi/Master/WebsiteTrackingdata",
        {
          params: {
            CNoteNo: searchInputs.join(","),
            refNo: searchInputs.join(","),
          },
        }
      );

      const data = res.data;

      if (data.status === 1 && data.Data) {
        const updatedData = data.Data.map((item: TrackingRecord) => ({
          ...item,
          ImageLink: `https://jaimarutilogistics.com/ShipwayApi/POD_Image/${item.DocketNo}.jpg`,
        }));

        setTrackingData(updatedData);
        setSearchValue("");

        if (updatedData.length > 0) {
          setCurrentStep(statusToStep[updatedData[0].Status] || 1);
        }
      } else {
        setTrackingData([]);
        setError("Docket Not Found");
        alert("Docket Not Found");
        setSearchValue("");
      }
    } catch (err: any) {
      console.error(err);

      const message =
        err.response?.data?.message ||
        "Failed to fetch data. Please check your internet connection or try again later.";

      setError(message);
      alert(message);
      setSearchValue("");
    }
  };



  return (
    <>

{/* ================= DESKTOP NAVBAR ================= */}
<header className="navbar-desktop">
  <div className="navbar-left">
    <img src={Aslogistics} alt="As Logistics" className="navbar-logo2" />
  </div>

  <nav className="navbar-center">
    <a href="https://aslogisticsexpress.com/index.html">Home</a>
    <a href="https://aslogisticsexpress.com/about.html">About Us</a>
    <a href="https://aslogisticsexpress.com/Document.html">Services</a>
    <a href="#">Tracking</a>
    <a href="https://aslogisticsexpress.com/contact.html">Contact Us</a>
  </nav>

  <div className="track-wrapper">
    <input
      type="text"
      className="track-input-new"
      placeholder="Enter AWB Number"
      value={searchValue}
      onChange={handleInputChange}
    />
    <button onClick={fetchData} className="track-btn-new">
      Track Shipment
    </button>
  </div>
</header>

{/* ================= MOBILE / TABLET NAVBAR ================= */}
<header className="navbar-mobile">
  <div className="mobile-header">
    <button
      className="menu-toggle"
      onClick={() => setMenuOpen(!menuOpen)}
    >
      ☰
    </button>

    <img src={Aslogistics} alt="As Logistics" className="mobile-logo" />
  </div>

  {menuOpen && (
    <div className="mobile-menu">
      <a href="https://aslogisticsexpress.com/index.html">Home</a>
      <a href="https://aslogisticsexpress.com/about.html">About Us</a>
      <a href="https://aslogisticsexpress.com/Document.html">Services</a>
      <a href="#">Tracking</a>
      <a href="https://aslogisticsexpress.com/contact.html">Contact Us</a>

      <div className="mobile-track">
        <input
          type="text"
          className="track-input-new"
          placeholder="Enter AWB Number"
          value={searchValue}
          onChange={handleInputChange}
        />
        <button onClick={fetchData} className="track-btn-new">
          Track Shipment
        </button>
      </div>
    </div>
  )}
</header>





      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-10 col-sm-12">
            <h5 className="BLuedarttracking1 text-center"><b>As Logistics Express Tracking Details</b></h5>

            {trackingData.length > 0 ? (
              trackingData.map((record, index) => (
                <div key={index} className="p-4 mb-4">
                  <div className="table-responsive-custom">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>Waybill No</th>
                          <th>Invoice No</th>
                          <th>Expected Date of Delivery</th>
                          <th>Status</th>
                          <th>Date of Delivery</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{record.DocketNo}</td>
                          <td>{record.InvoiceNo}</td>
                          <td>{record.ExptDateDelivery}</td>
                          <td>{record.Status}</td>
                          <td>{record.statusDt}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              ))
            ) : (
              <div className="text-center">No tracking data available.</div>
            )}

            {/* Progress Steps */}
            <div className="steps-wrapper">
              <div className="steps-container">
                {[1, 2, 3].map((number) => (
                  <div key={number} className="step">
                    <div className={`step-circle2 ${number <= currentStep ? 'active' : ''}`}>
                      {number}
                    </div>
                    <div className="step-label">
                      {number === 1 ? 'Shipped' : number === 2 ? 'In Transit' : 'Delivered'}
                    </div>
                  </div>
                ))}

                {/* Progress line */}
                <div className="progress-line">
                  <div
                    className="progress-fill"
                    style={{ width: `${((currentStep - 1) / 2) * 100}%` }}
                  ></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      {/* Tabs Section */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-10 col-sm-12">
            <Tabs defaultActiveKey="details" id="uncontrolled-tab-example" className="custom-tabs">
              {/* Shipment Details Tab */}
              <Tab eventKey="details" title="Shipment Details">
                {trackingData.length > 0 ? (
                  trackingData.map((record, index) => (

                    <div key={index} className="mb-4">
                      <div className="shipment-table-container">
                        <table className="blue-table">
                          <thead className='blue-table'>
                            <tr>
                              <th className="blue-header">Shipment Details</th>
                              <th className="blue-header">Details</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr><td>Waybill No</td><td>{record.DocketNo}</td></tr>
                            <tr><td>Forwarding No</td><td>{record.VendorAwbNo || '-'}</td></tr>
                            <tr><td>Pickup Date</td><td>{record.bookdate}</td></tr>
                            <tr><td>From</td><td>{record.Origin_Name}</td></tr>
                            <tr><td>To</td><td>{record.Destination_Name}</td></tr>
                            <tr><td>Qty</td><td>{record.Qty}</td></tr>
                            <tr><td>EWaybill</td><td>{record.EWaybill}</td></tr>
                            <tr><td>Status</td><td>{record.Status}</td></tr>
                            <tr><td>Date of Delivery</td><td>{record.statusDt || '-'}</td></tr>
                          </tbody>
                        </table>
                      </div>




                      {/* Show/Hide POD Button */}
                      <button className="pod-btn-blue mt-3" onClick={handleButtonClick}>
                        {showImage ? "Hide Image" : "Show POD Image"}
                      </button>

                      {/* POD Image */}
                      {showImage && record.ImageLink && (
                        <div className="image-container mt-3 text-center">
                          <img
                            src={record.ImageLink}
                            alt="POD"
                            className=""
                            style={{ maxWidth: "600px", borderRadius: "6px" }}
                          />
                        </div>
                      )}
                    </div>


                  ))
                ) : (
                  <div className="text-center">No shipment details available.</div>
                )}
              </Tab>

              {/* Status and Scans Tab */}
              <Tab eventKey="status" title="Status and Scans">
                {trackingData.length > 0 ? (
                  trackingData.map((record, index) => (
                    <div key={index} className="mb-3">
                      <div className="scrollable-table">
                        <table className="blue-table">
                          <thead>
                            <tr>
                              <th>DocketNo</th>
                              <th>Location</th>
                              <th>Status</th>
                              <th>Status Date</th>
                              <th>Time</th>
                            </tr>
                          </thead>

                          <tbody>
                            {record.StatusEntry && record.StatusEntry.length > 0 ? (
                              record.StatusEntry.map((entry: TempodEntry, idx: number) => (
                                <tr key={idx}>
                                  <td>{entry.DocketNo}</td>
                                  <td>{entry.Destination_Name}</td>
                                  <td>{entry.Status}</td>
                                  <td>{entry.DelvDt}</td>
                                  <td>{entry.DelvTime}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5}>No scans available.</td>
                              </tr>
                            )}

                          </tbody>

                        </table>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center">No status and scans available.</div>
                )}
              </Tab>



            </Tabs>
          </div>
        </div>
      </div>


      {/* News Section */}
      <div className="container mt-4">
        <div className="marquee-container">
          <div className="marquee-content">
            {/* <Row className="flex-nowrap">
              {news.map((item, idx) => (
                <Col key={idx} className="marquee-col" style={{ position: "relative" }}>
                  <Card
                    className="shadow-sm border-0 h-100 position-relative"
                    style={{
                      borderRadius: "15px",
                      padding: "20px",
                      textAlign: "left",
                      overflow: "hidden",
                    }}
                  >
                    <span className="new-badge">NEW</span>
                    <Card.Body>
                      <Card.Title style={{ fontWeight: "700", fontSize: "1.2rem", color: "#222" }}>
                        {item.date}
                      </Card.Title>
                      <Card.Text>
                        <a href={item.link} style={{ color: "#007bff", textDecoration: "none", fontWeight: "500" }}>
                          {item.title}
                        </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row> */}
          </div>
        </div>
      </div>



      {/* Footer */}

      <footer className="jd-footer">
        <div className="container">
          <div className="row">

            {/* Column 1 */}
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <img src={as} alt="JD Cargo Logo" className="as" />

              <p>
                We are committed and dedicated in fulfilling our obligation to our valued customer by offering quality services that meets all the demands and day to day requirements of our clients, which makes us a reputed courier and cargo company in India... Read More
              </p>

              <div className="jd-social">
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-facebook"></i></a>
              </div>
            </div>

            {/* Column 2 */}
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="https://aslogisticsexpress.com/index.html">Home</a></li>
                <li><a href="https://aslogisticsexpress.com/about.html">About Us</a></li>
                <li><a href="https://aslogisticsexpress.com/ourservice.html">Our Services</a></li>
                <li><a href="#">Premium Air</a></li>
                <li><a href="#">Terms Of Service</a></li>
                <li><a href="https://jdcargo.co.in/contact-us.php">Contact Us</a></li>
              </ul>
            </div>

            {/* Column 3 */}
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <h4>Our Services</h4>
              <ul>
                <li><a href="#">Air Freight</a></li>
                <li><a href="#">Train Freight</a></li>
                <li><a href="#">Road Freight</a></li>
                <li><a href="#">Warehousing</a></li>
                <li><a href="#">Supply Chain</a></li>
                <li><a href="#">Packaging</a></li>
              </ul>
            </div>

            {/* Column 4 */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <h4>Get in Touch</h4>
              <p>
                A-66,Green Farm Road No. 4, Room No. 102, Street No. 7,
                Mahipalpur, New Delhi – 110037
              </p>
              <p>
                <strong>Email:</strong>info@aslogisticsexpress.com<br />
                Contact: +91 7011209462, +91 8383872690, <br />
                <a href="mailto:info@aslogisticsexpress.com">info@aslogisticsexpress.com</a>
              </p>
            </div>

          </div>
        </div>



        <div className="jd-footer-bottom">
          © {new Date().getFullYear()} As Logistics Express. All rights reserved.
        </div>

      </footer>

    </>
  );
};

export default AsTracking;
